<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            老人入住自动扣费记录
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
                
            </div>
            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
                        <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                        <el-table-column label="手机号" prop="phone"></el-table-column>
                        <el-table-column label="身份证号" prop="idCard"></el-table-column>
                        <el-table-column label="扣费金额（元）" prop="money"></el-table-column>
                        <el-table-column label="扣费类型" prop="deductionType">
                            <template slot-scope="scope">
                                <span v-if="scope.row.deductionType=='one'">固定费用</span>
                                <span v-if="scope.row.deductionType=='mul'">月费用</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="startTime" :formatter="formatterTime1" label="扣费开始时段" width="150"></el-table-column>
                        <el-table-column prop="endTime" :formatter="formatterTime1" label="扣费结束时段" width="150"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="扣费时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr,getCurrentMonthTime} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                startTime:getCurrentMonthTime()[0],
                endTime:getCurrentMonthTime()[1],
                tableData:null,
                elderlyName:null,
                datetimerangeValue:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
            }
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            formatterTime1(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,10):null
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DeductionRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        console.log(response.data.data);
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>


</style>
